import { PaymentMethodCodes } from "modules/entities";

export const defaultBank = PaymentMethodCodes.bni;
